// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"220":"db2850dd","267":"440d45d7","708":"5ece18d4","879":"da64c4c6"}[chunkId] + ".css";
};